export default __webpack_public_path__ + "static/media/download_icon.d21d6dfe.svg";